export default {
    search: 'Search',
    confirmation: {
        title: 'Deactivate Company Mega Trend',
        notice: 'If you deactivate a Company Mega Trend, all associated Company Macro Trends will also be deactivated.',
        confirm: 'Deactivate'
    },
    filterOptions: {
        active: 'Active',
        inactive: 'Inactive'
    },
    header: {
        megatrend: 'Mega-trend',
        macrotrends: 'Macro-trends',
        state: 'Active?',
        actions: 'Actions'
    },
    delete: {
        question: 'Delete company-mega-trend&nbsp;<strong>"{title}"</strong>?',
        notice: 'Attention: This action <strong>cannot</strong> be undone!',
        success: 'Company-mega-trend was successfully deleted!',
        action: {
            close: 'Close',
            delete: 'Delete'
        },
        notDeletable: {
            title: 'Company-mega-trend&nbsp;<strong>"{title}"</strong>&nbsp;is not deletable',
            text: 'Relations to company-macro-trends still exist',
            close: 'Close'
        }
    },
    tooltip: {
        edit: 'Edit company mega trend',
        delete: 'Delete company mega trend'
    }
}
